module.exports = __webpack_public_path__ + "static/media/imgTaskDefault.902483cb.jpeg";